export const HOTJAR_ID = process.env.NEXT_PUBLIC_HOTJAR_ID ?? "";
